module.exports = __webpack_public_path__ + "img/测点_正常全图.788ed471.png";